import React from "react";
import {
  Grid,
  TextField,
  Checkbox,
  FormControlLabel,
  Button,
  Typography,
  Paper,
} from "@mui/material";
import { useForm, Controller, SubmitHandler } from "react-hook-form";

interface IFormInput {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  consent: boolean;
}

const ContactForm: React.FC = () => {
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<IFormInput>();

  const onSubmit: SubmitHandler<IFormInput> = (data) => {
    console.log("Form Data:", data);
  };

  return (
    <Paper elevation={3} sx={{ padding: "16px" }}>
      <div className="font-semibold leading-6 text-gray1 mb-2">
        Contact Form
      </div>

      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Grid container spacing={2}>
          {/* First Name */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              variant="standard"
              label="First Name"
              {...register("firstName", { required: "First name is required" })}
              error={!!errors.firstName}
            />
          </Grid>

          {/* Last Name */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              variant="standard"
              label="Last Name"
              {...register("lastName", { required: "Last name is required" })}
              error={!!errors.lastName}
            />
          </Grid>

          {/* Email */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              variant="standard"
              label="Email"
              type="email"
              {...register("email", {
                required: true,
                pattern: {
                  value: /^\S+@\S+$/i,
                  message: "Invalid email address",
                },
              })}
              error={!!errors.email}
              helperText={errors.email?.message}
            />
          </Grid>

          {/* Phone */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              variant="standard"
              label="Phone"
              {...register("phone", {
                required: true,
                pattern: {
                  value:
                    /^(\+91[\s-]?)?[6-9]\d{9}$|^(\+31[\s-]?6\d{8}|06\d{8})$/,
                  message: "Enter a valid phone number",
                },
              })}
              error={!!errors.phone}
              helperText={errors.phone?.message}
            />
          </Grid>

          {/* Consent */}
          <Grid item xs={12}>
            <Controller
              name="consent"
              control={control}
              defaultValue={false}
              rules={{ required: "You must agree before submitting" }}
              render={({ field }) => (
                <FormControlLabel
                  control={<Checkbox {...field} checked={field.value} />}
                  label="I agree to the terms and conditions"
                />
              )}
            />
            {errors.consent && (
              <Typography variant="caption" color="error">
                {errors.consent.message}
              </Typography>
            )}
          </Grid>

          {/* Submit */}
          <Grid item xs={12}>
            <Button type="submit" variant="contained" color="primary" fullWidth>
              Submit
            </Button>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
};

export default ContactForm;
